import {
  formatCurrency,
  formatDiscount,
} from "../booking-configurator/formatters"
import InvoiceItem from "../booking-configurator/invoice-item"
import PromoCodeForm from "./promo-code-form"

const OrderSummary = ({
  cart,
  inventoryPageSnapshots,
  firestore,
  promoCode,
  setPromoCode,
  orderCurrency,
  orderDiscount,
  cartTotal,
}) => {
  const lineItemDiscounts = Object.values(cart || {})
    .map((_) => _.discount)
    .filter((_) => _)

  const isEmptyCart =
    Object.keys(cart).filter((k) => k !== "createdAt").length === 0

  return (
    <>
      {/* Inventory page totals */}
      <p className="font-bold text-2xl whitespace-nowrap">Summary:</p>
      <div className="flex flex-col gap-8">
        {inventoryPageSnapshots.map((snapshot) => {
          const inventoryPage = snapshot.data()
          const inventoryInCart = cart[snapshot.ref.id]
          const quantity = inventoryInCart.quantity
          const { amountInCents } =
            inventoryPage.prices.onDemand[orderCurrency.toLowerCase()]

          const discount =
            inventoryInCart.discount && inventoryPage.discount
              ? inventoryPage.discount
              : 0

          const discountInCents = discount * amountInCents * quantity

          return (
            <div key={snapshot.ref.id} className="flex flex-col gap-2">
              <p>{inventoryPage.name}</p>

              <InvoiceItem
                label={`${formatCurrency(
                  amountInCents,
                  orderCurrency
                )} × ${quantity} day${quantity > 1 ? "s" : ""}`}
                value={`${amountInCents * quantity}`}
                currency={orderCurrency}
              />

              {discountInCents > 0 && (
                <InvoiceItem
                  label={`Discount (${formatDiscount(inventoryPage.discount)})`}
                  value={`${discountInCents}`}
                  currency={orderCurrency}
                />
              )}
            </div>
          )
        })}
      </div>
      {isEmptyCart || lineItemDiscounts.length > 0 ? null : (
        <div className="mt-6">
          <PromoCodeForm
            firestore={firestore}
            promoCode={promoCode}
            setPromoCode={setPromoCode}
            orderCurrency={orderCurrency}
            promoCodeDiscount={orderDiscount}
          />
        </div>
      )}

      {!isEmptyCart && <div className="h-[1px] w-full bg-gray-300" />}

      <InvoiceItem
        label="Total *"
        boldLabel
        value={cartTotal}
        currency={orderCurrency}
      />
    </>
  )
}

export default OrderSummary
